export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    /* GF Uses hard coded ID's */
    function toggle_blog_newsletter() {
      if (jQuery('#input_2_6').length) {
        jQuery('#choice_2_5_1').change(function () {
          if (this.checked) {
            jQuery('#input_2_6').val('Yes');
          } else {
            jQuery('#input_2_6').val('No');
          }
        });
      }
    }
    toggle_blog_newsletter();

    /* Sticky Header + scroll */
    function sticky_header() {

      if(jQuery('body').hasClass('target-desktop')) {

        /* Sticky Header */
        var lastScrollTop = 0;

        jQuery(window).scroll(function () {

          // On scroll down add sticky header class for basic setup
          var scroll = jQuery(window).scrollTop();
          if (scroll >= jQuery('.top-header').outerHeight()) {
            jQuery('.main-header-content').addClass('sticky-header-show');
          } else {
            jQuery('.main-header-content').removeClass('sticky-header-show');
          }

          // On scroll up fade in
          if (scroll >= jQuery('.top-header').outerHeight() && scroll < lastScrollTop) {
            jQuery('.main-header-content').addClass('header-fade-in');
            jQuery('.main-header-content').removeClass('header-fade-out');
            if (jQuery('nav.navbar').length) {
              jQuery('nav.navbar').addClass('header-offset');
            }
          } else {
            jQuery('.main-header-content').addClass('header-fade-out');
            jQuery('.main-header-content').removeClass('header-fade-in');
            if (jQuery('nav.navbar').length) {
              jQuery('nav.navbar').removeClass('header-offset');
            }
          }

          lastScrollTop = scroll;

        });

      } else if (jQuery('body').hasClass('target-mobile')) {

        jQuery(window).scroll(function () {

          var scroll = jQuery(window).scrollTop();
          if (scroll >= 1) {
            jQuery('.main-header-content').addClass('sticky-header-show');
          } else {
            jQuery('.main-header-content').removeClass('sticky-header-show');
          }

        });

      }

    }



    /* Header search icon toggle */

    function search_form_toggle() {

      jQuery('.search-trigger i').click(function(){

        // Dynamic Width
        var menuPos = jQuery('header .menu-container').offset();
        var searchPos = jQuery('header .search-trigger').offset()
        var width = searchPos.left - menuPos.left;

        jQuery('body').addClass('search-open');
        jQuery('.search-trigger .search-wrap form').css({'width':width});
        jQuery('.search-trigger .search-wrap').show();
        jQuery('.search-trigger .search-wrap input[type="text"]').focus();

      });

      jQuery('.overlay, .search-close').click(function(){
        jQuery('body').removeClass('search-open');
        jQuery('.search-trigger .search-wrap').hide();
      });

      jQuery(window).scroll(function() {
        jQuery('body').removeClass('search-open');
        jQuery('.search-trigger .search-wrap').hide();
      });

    }


    /* Section layouts need to break the content width layout to enable fullwidth option */
    // function section_full_width() {
    //
    //     var windowWidth = jQuery('body').innerWidth();
    //     var contentWidth = jQuery('.content').outerWidth();
    //     var calc = (windowWidth - contentWidth) / 2;
    //     console.log('content: ' + contentWidth + ' calc: ' + calc);
    //
    //     // Build dynamic <style> tag rather than edit every matching dom element
    //     // in theory faster load times ^ replaces the each loop above
    //     if (!jQuery('#sectionWidth').length) {
    //       jQuery('body').prepend('<style id="sectionWidth">.ct-section { margin-left: -' + calc + 'px; width: ' + windowWidth + 'px; }</style>');
    //     } else {
    //       jQuery('#sectionWidth').html('.ct-section { margin-left: -' + calc + 'px; width: ' + windowWidth + 'px; }');
    //     }
    //
    //     // Blog post breaks layout.
    //     if (jQuery('body').hasClass('single-post')) {
    //       var recalc = (windowWidth - jQuery('.blog-wrap').outerWidth()) / 2;
    //       jQuery('.blog-wrap .ct-section').each(function () {
    //         jQuery(this).css({'margin-left': -recalc});
    //       });
    //     }
    //
    // }


    /* Section min heights to be set dynamically */
    // function dynamic_section_min_heights() {
    //   var wpadminbar = 0;
    //   if(jQuery('#wpadminbar').length) { wpadminbar = jQuery('#wpadminbar').height(); }
    //   var header = 0;
    //   if(jQuery('body').hasClass('target-mobile')) {
    //     header = jQuery('.main-header-content').outerHeight();
    //   } else {
    //     header = jQuery('header').height();
    //   }
    //   var screen = jQuery(window).height();
    //
    //   var fullScreen = screen - header - wpadminbar;
    //   var semifullScreen = (fullScreen / 4) * 3;
    //   var halfScreen = fullScreen / 2;
    //
    //   // jQuery('.section-height-full').each(function () { jQuery(this).css({'height':fullScreen}); });
    //   // jQuery('.section-height-semifull').each(function () { jQuery(this).css({'height':semifullScreen}); });
    //   // jQuery('.section-height-half').each(function () { jQuery(this).css({'height':halfScreen}); });
    //
    //   if(!jQuery('#sectionHeights').length) {
    //     jQuery('body').prepend('<style id="sectionHeights">' +
    //       '.section-height-full, .section-height-full-screen { min-height: ' + fullScreen + 'px; }' +
    //       '.section-height-semifull, .section-height-semi-full, .section-height-semi-full-screen { min-height: ' + semifullScreen + 'px; }' +
    //       '.section-height-half, .section-height-half-screen { min-height: ' + halfScreen + 'px; }' +
    //       '</style>');
    //   } else {
    //     jQuery('#sectionHeights').html(
    //       '.section-height-full { min-height: ' + fullScreen + 'px; }' +
    //       '.section-height-semifull { min-height: ' + semifullScreen + 'px; }' +
    //       '.section-height-half { min-height: ' + halfScreen + 'px; }'
    //     );
    //   }
    //
    // }


    function loadMorePosts() {

      jQuery('.post-wrap').each(function(){

        var $this = jQuery(this);

        if(jQuery($this).find('.read-more-btn').length) {

          jQuery($this).find('.read-more-btn').click(function(){

            var paged = parseInt($this.attr('data-paged')) + 1;
            var postType = $this.attr('data-posttype');
            var limit = $this.attr('data-limit');
            var offset = jQuery(this).offset().top - 100;
            var term = $this.attr('data-taxo-term');

            jQuery.ajax({ // eslint-disable-next-line no-undef
              url: mainAjax.url,
              data: {
                'action': 'ajaxLoadMorePosts',
                'paged' : paged,
                'postType' : postType,
                'limit' : limit,
                'category' : term,
              },
              success:function(data) {
                jQuery($this).find('.row').append(data);
                $this.attr('data-paged',paged);
                console.log(term);
                jQuery([document.documentElement, document.body]).animate({
                  scrollTop: offset,
                }, 500);
              },
              error: function(errorThrown){
                console.log(errorThrown);
              },
            });

          });

        }

      });

    }

    /* eslint-disable */
    function sticky_navbar() {

      if(jQuery('nav.navbar').length) {
        var stickySidebar = jQuery('nav.navbar.main-nav').offset().top + 140;
        var headerHeight = 66;

        var prevLeft = 0;
        jQuery(window).scroll(function () {
          var currentLeft = jQuery(window).scrollLeft();
          if(prevLeft === currentLeft) {

            if (jQuery(window).scrollTop() > stickySidebar) {
              if(jQuery('.target-desktop nav.navbar.main-nav').length) {
                jQuery('nav.navbar.main-nav').addClass('nav-sticky');
              }
              if(jQuery('.target-mobile nav.navbar.main-nav').length) {
                //jQuery('.target-mobile nav.navbar.main-nav').css({'top': headerHeight + 'px'});
              }
            } else {
              if(jQuery('.target-desktop nav.navbar.main-nav').length) {
                jQuery('nav.navbar.main-nav').removeClass('nav-sticky');
              }
              if(jQuery('.target-mobile nav.navbar.main-nav').length) {
                //jQuery('.target-mobile nav.navbar.main-nav').css({'top': '0px'});
              }
            }


            jQuery('nav.navbar.main-nav li a').each(function (i) {

              var target = jQuery(this).attr('href');
              var targetMain = jQuery(this);


              // ignore non hash links AND make sure target hash finds an element by that ID
              if (target.indexOf('#') != -1) {

                var position = targetMain.offset().top - 100;

                if (jQuery(window).scrollTop() > position) {
                  jQuery('nav.navbar.main-nav li.active').removeClass('active');
                  jQuery(this).parent().addClass('active');
                  jQuery('.navbar-counter').val(i).trigger('change');
                } else {
                  jQuery(this).parent().removeClass('active');
                }

              }

            });

          }

        });
      }

    }


    function mobile_scroll_navbar() {

      if(jQuery('.accomm-navbar').length) {

        jQuery('.accomm-navbar .navbar-expand .navbar-nav').each(function(){

          var width = 0;
          var count = 0;

          jQuery(this).find('.nav-item').each(function(){
            width += jQuery(this).width();
            count += 10;
          });

          var total = width + count;
          jQuery(this).css({'width':total + 'px'});

        });

      }

    }


    function testimonialSlider() {

      if(jQuery('.testimonial-slider').length) {

        jQuery('.testimonial-slider').each(function(){

          var $this = jQuery(this);
          var $parent = jQuery(this).parent();
          var $status = jQuery($parent).find('.testimonial-slider-meta .count');

          $this.on('init reInit afterChange', function (event, slick, currentSlide) {
            var i = (currentSlide ? currentSlide : 0) + 1;
            $status.text(i + '/' + slick.slideCount);
          });

          $this.slick({
            centerMode: true,
            autoplay: true,
            dots: false,
            arrows: false,
            slidesToShow: 3,
            autoplaySpeed: 4000,
            responsive: [
              {
                breakpoint: 780,
                settings: {
                  slidesToShow: 2,
                  centerMode: false,
                }
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 1,
                  centerMode: false,
                }
              },
            ]
          });

          var $slides = $this.find('.testimonial-info').length;
          if($slides < 4){
            $this.slick('slickSetOption', 'centerMode', false);
            $this.addClass('centerFalse');
            jQuery($parent).find('.testimonial-slider-meta').hide();
          }

          jQuery($parent).find('.testimonial-slider-meta .prev').click(function() {
            jQuery($this).slick('slickPrev');
          });
          jQuery($parent).find('.testimonial-slider-meta .next').click(function() {
            jQuery($this).slick('slickNext');
          });

        });

      }


    }


    function taxonomySlider() {

      if(jQuery('.taxonomyslider').length) {

        jQuery('.taxonomyslider .taxonomy-slider-container').each(function(){

          var $this = jQuery(this);
          var $parent = jQuery(this).parent();
          var $status = jQuery($parent).find('.taxonomy-slider-meta .count');

          $this.on('init reInit afterChange', function (event, slick, currentSlide) {
            var i = (currentSlide ? currentSlide : 0) + 1;
            $status.text(i + '/' + slick.slideCount);
          });
    
          $this.slick({
            centerMode: true,
            autoplay: true,
            dots: false,
            arrows: false,
            slidesToShow: 3,
            autoplaySpeed: 4000,
            responsive: [
              {
                breakpoint: 780,
                settings: {
                  slidesToShow: 2,
                  centerMode: false,
                }
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 1,
                  centerMode: false,
                }
              },
            ]
          });

          // disable center mode if less than 3 slides
          var $slides = $this.find('.taxonomy-item').length;
          if($slides < 4){
            $this.slick('slickSetOption', 'centerMode', false);
            $this.addClass('centerFalse');
            jQuery($parent).find('.taxonomy-slider-meta').hide();
          }

          jQuery($parent).find('.taxonomy-slider-meta .prev').click(function() {
            jQuery($this).slick('slickPrev');
          });
          jQuery($parent).find('.taxonomy-slider-meta .next').click(function() {
            jQuery($this).slick('slickNext');
          });
    
    
        });

      }

    }



    function HolidayTypeSlider() {

      if(jQuery('.holiday-type-slider-wrap').length) {

        jQuery('.holiday-type-slider').each(function(){

          var $this = jQuery(this);
          var $parent = jQuery(this).parent();
          var $status = jQuery($parent).find('.holiday-type-slider-meta .count');

          $this.on('init reInit afterChange', function (event, slick, currentSlide) {
            var i = (currentSlide ? currentSlide : 0) + 1;
            $status.text(i + '/' + slick.slideCount);
          });
    
          $this.slick({
            centerMode: true,
            autoplay: true,
            dots: false,
            arrows: false,
            slidesToShow: 3,
            autoplaySpeed: 4000,
            responsive: [
              {
                breakpoint: 780,
                settings: {
                  slidesToShow: 2,
                  centerMode: false,
                }
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 1,
                  centerMode: false,
                }
              },
            ]
          });

          // disable center mode if less than 3 slides
          var $slides = $this.find('.holiday-type').length;
          if($slides < 4){
            $this.slick('slickSetOption', 'centerMode', false);
            $this.addClass('centerFalse');
            jQuery($parent).find('.holiday-type-slider-meta').hide();
          }

          jQuery($parent).find('.holiday-type-slider-meta .prev').click(function() {
            jQuery($this).slick('slickPrev');
          });
          jQuery($parent).find('.holiday-type-slider-meta .next').click(function() {
            jQuery($this).slick('slickNext');
          });
    
    
        });

      }

    }
    

    function blog_menu_scroller() {

      if (jQuery(window).width() < 780) {

        if (jQuery('.blog-submenu').length) {

          var width = 0;
          var count = 0;

          jQuery('.blog-submenu ul li').each(function () {
            width += jQuery(this).outerWidth();
            count += 30;
          });

          var total = parseInt(width) + parseInt(count);
          jQuery('.blog-submenu .container').css({'width': total + 'px'});
          jQuery('.blog-submenu .container').css({'max-width': total + 'px'});

        }

      }

    }


    function postGridAjax($this) {

            var ids = jQuery($this).attr('data-postids');
            var paged = parseInt(jQuery($this).attr('data-paged'));
            var next = paged + 1;
            var limit = parseInt(jQuery($this).attr('data-limit'));

            jQuery.ajax({ // eslint-disable-next-line no-undef
              url: mainAjax.url,
              data: {
                'action': 'ajaxPostGrid',
                'ids': ids,
                'paged': paged
              },
              success: function (data) {
                if(data) {
                  jQuery($this).attr('data-paged',next);
                  jQuery($this).find('.row.post-grid-data').append(data);
                }
                if(next == limit) {
                  jQuery($this).find('.post-grid-button').css({'display':'none'});
                }
              },
              error: function (errorThrown) {
                console.log(errorThrown);
              },
            });

    }


    function postGridAjaxInit() {

      if(jQuery('.post-grid-ajax').length) {

        jQuery('.post-grid-ajax').each(function() {
          postGridAjax(jQuery(this));
        });

      }

    }


    function postGridAjaxTrigger() {

      if(jQuery('.post-grid-ajax').length) {
        jQuery('.post-grid-ajax').each(function() {

          var $this = jQuery(this);
          var btn = jQuery(this).find('.post-grid-button');

          jQuery(btn).click(function(e){
            e.preventDefault();
            postGridAjax($this);
          })


        });
      }

    }


    function overview_full_height() {

      var target = 'body.archive.target-desktop .accomm-navbar .navbar';
      var height = jQuery(target).outerHeight();
      jQuery(target).css({'margin-top':'-' + height + 'px'});

    }


    function custom_read_more() {

      if(jQuery('.overview-controller').length) {

        jQuery('.overview-controller .btn-secondary').click(function(){
          jQuery('.overview-controller').toggleClass('overview-active');
        });

      }

    }


    // On load
    jQuery(window).on('load', function(){

      // section_full_width();
      // dynamic_section_min_heights();
      testimonialSlider();
      taxonomySlider();
      HolidayTypeSlider();

      /* Scroll Nav Bar */
      if(jQuery('body').hasClass('target-mobile')) {
        mobile_scroll_navbar();
      }

      blog_menu_scroller();
      jQuery(window).resize(function () {
        blog_menu_scroller();
      });

      // overview_full_height();

    });

    // On browser resize
    jQuery(window).on('resize', function(){
      // section_full_width();
      // dynamic_section_min_heights();
    });


    jQuery(document).ready(function(){

      // Post grid
      postGridAjaxInit();
      postGridAjaxTrigger();

      /* Bootstrap Accordion */
      jQuery('#itinerary-breakdown').on('hidden.bs.collapse', function (e) {
        jQuery(e.target).parent().removeClass('toggle-open');
      });
      jQuery('#itinerary-breakdown').on('show.bs.collapse', function (e) {
        jQuery(e.target).parent().addClass('toggle-open');
      });

      /* Sticky Header */
      sticky_header();

      /* Search Toggle */
      search_form_toggle();

      if(jQuery('.searchselect select').length && typeof select2 == 'function') {
        jQuery('.searchselect select').select2();
      }

      if(jQuery('.conversionRates').length && typeof select2 == 'function') {
        jQuery('.conversionRates').select2({
          minimumResultsForSearch: -1, // Disable the select search
          dropdownCssClass : 'currency-dropdown',
        });
      }

      /* Load more posts AJAX */
      loadMorePosts();

      /* Sticky Nav Bar */
      sticky_navbar();



      /* Select2 for sort filters */
      if(jQuery('.sort-filter-wrap select').length && typeof select2 == 'function') {
        jQuery('.sort-filter-wrap select').each(function(){
          jQuery(this).select2();
        });
      }


      jQuery(".mobile-menu span").on("click", function(e){
        e.preventDefault();
        e.stopPropagation();
        jQuery('.header-actions').toggleClass('menu-opened')
        jQuery('#main-menu-mobile').toggleClass("show");
        jQuery('body').toggleClass("offcanvas-active");
      });

      jQuery(".btn-close, .screen-overlay").click(function(e){
        jQuery(".offcanvas").removeClass("show");
        jQuery("body").removeClass("offcanvas-active");
      });

      custom_read_more();


    });
      
      
      // jQuery(document).ready(function() {
      //     setTimeout(function(){
      //     	jQuery('.home .post-grid-ajax .post-grid-data').slick({slidesToShow: 3, responsive: [ { breakpoint:600, settings: { slidesToShow: 1} } ]});
      //     }, 2000);
      // });


  },
}


// WEBPACK FOOTER //
// ./scripts/routes/common.js